import React, { useRef, useState, useEffect } from "react";

import useHttp from "../../hooks/use-http";
import { toast } from "react-toastify";
import Pagination from "../../components/Pagination";
import ReactFileReader from "react-file-reader";
import { utils, read } from "xlsx";
const VendorUpload = (props) => {
  const frmRef = useRef({});
  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [profileUrl, setprofileUrl] = useState();
  const [attachmentUrl, setAttachmentUrl] = useState();

  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

 // //console.log(integerPattern);

  const { sendRequest: postAddVendor } = useHttp();

  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData = utils.sheet_to_json(worksheet, { header: 1 });

    // console.log("parsedData", parsedData);
    var count = parsedData.length;
    var newList = [];

    try
    {
    for (var k = 1; k < count; k++) {
      var item = parsedData[k];
    //  console.log("item", item);
      if (item[0] != "") {
        newList = newList.concat({
          srNo: k,
          vendorName: item[0],
          contactPersonName: item[1],
          status: 1,
          email: item[2],
          IdProof: item[3],
          contactWork: item[4],
          whatsapp: item[5],
          registeredAddress: item[6],
          vendorCity: item[7],
          vendorState: item[8],
          vendorCountry: item[9],
          vendorzipCode: item[10],
          officeAddress: item[11],
          officeCity: item[12],
          officeState: item[13],
          officeCountry: item[14],
          officezipCode: item[15],
          is_goodsSupplier: item[16],
          is_workServiceProvider: item[17],
          is_machinServices: item[18],
          is_mainteinance: item[19],
          is_labourServices: item[20],
          bankAcNo: item[21],
          AccountHolderName: item[22],
          IFSC: item[23],
          paymentTermsDays: item[24],
          orgId: localStorage.getItem("orgId"),
          createdBy: localStorage.getItem("id"),
          warehouseName: item[25],
        });
      }
    }
  }catch(error)
  {
    // console.log("error",error)
  }
  // console.log("newList",newList)
    setData(newList);
  };

  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };


  //   //// //console.log(props.update);
  //   if (props.update) {
  //     frmRef.current.vendor_name.value = props.update.vendorName;
  //     frmRef.current.contact_person_name.value = props.update.contactPersonName;
  //     frmRef.current.status.value = props.update.status;
  //     frmRef.current.email_id.value = props.update.email;
  //     frmRef.current.id_proof.value = props.update.IdProof;
  //     frmRef.current.work_contact_number.value = props.update.contactWork;
  //     frmRef.current.whatsapp.value = props.update.whatsapp;
  //     frmRef.current.registered_address.value = props.update.registeredAddress;
  //     frmRef.current.vendor_city.value = props.update.vendorCity;
  //     frmRef.current.r_state.value = props.update.vendorState;
  //     frmRef.current.vendor_zipcode.value = props.update.vendorzipCode;
  //     frmRef.current.vendor_country.value = props.update.vendorCountry;
  //     frmRef.current.office_address.value = props.update.officeAddress;
  //     frmRef.current.office_city.value = props.update.officeCity;
  //     frmRef.current.office_state.value = props.update.officeState;
  //     frmRef.current.office_zipcode.value = props.update.officezipCode;
  //     frmRef.current.office_country.value = props.update.officeCountry;
  //     frmRef.current.goods_supplier.checked = props.update.is_goodsSupplier;
  //     frmRef.current.work_service_provider.checked =
  //       props.update.is_workServiceProvider;
  //     frmRef.current.machine_vehicle_equipement.checked =
  //       props.update.is_machinServices;
  //     frmRef.current.maintenance.checked = props.update.is_mainteinance;
  //     frmRef.current.labour_services.checked = props.update.is_labourServices;
  //     frmRef.current.account_number.value = props.update.bankAcNo;
  //     frmRef.current.account_holder_name.value = props.update.AccountHolderName;
  //     frmRef.current.ifsc_code.value = props.update.IFSC;
  //     frmRef.current.payment_terms_days.value = props.update.paymentTermsDays;
  //   }
  //   setAttachmentUrl(props.update.attachmentUrl);
  //   setBackImage(`${process.env.REACT_APP_FILE_URL}${props.update.profileUrl}`);
  // }, [props.update]);

  const submitHandler = (e) => {
    e.preventDefault();

   // //console.log("Data", data);
    postAddVendor(
      {
        url: "/api/vendorUpload/",
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`Vendor ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">&nbsp;
                <div className="card">
                  <div className="card-body">
                    <div className="row"> </div>
                    <div className="row">
                      <div className="col-4">
                        {" "}
                        <label className="card-title mx-2 my-3 ">
                          Vendor Details
                        </label>
                      </div>
                      <div className="col-4"> </div>
                      <div className="col-2"> </div>
                      <div className="col-2">
                        <ReactFileReader
                          handleFiles={handleFileUpload}
                          fileTypes={".xlsx"}
                        >
                          <button
                            type="button"
                            className="btn  btn-primary mx-2 my-2"
                          >
                            Upload Excel
                          </button>
                        </ReactFileReader>{" "}
                      </div>
                    </div>
                    <div className="row"> </div>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4"> </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered table-responsive text-center table-sm">
                        <thead>
                          <tr>
                            <th> Vendor Name </th> <th>Contact Person Name </th>
                            <th>Email </th> <th>Id Proof </th>
                            <th>Contact Work</th>
                            <th>Whatsapp No </th> <th>Registered Address </th>
                            <th>Registered City </th>
                            <th>Registered State</th>
                            <th>Registered Country </th>
                            <th>Registered ZipCode</th> <th> Office Address</th>
                            <th>Office City</th> <th>Office State</th>
                            <th>Office Country</th> <th>Office ZipCode</th>
                            <th>Is Goods Supplier</th>
                            <th>Is Work Service Provider</th>
                            <th>Is Machin Services</th> <th>Is Mainteinance</th>
                            <th>Is Labour Services</th> <th>Bank Account No</th>
                            <th>Account Holder Name</th> <th>IFSC</th>
                            <th>Payment Terms(Days)</th>
                            <th>Warehouse Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.vendorName}</td>
                                <td>{x.contactPersonName}</td>
                                <td>{x.email}</td>
                                <td>{x.IdProof}</td>
                                <td>{x.contactWork}</td>
                                <td>{x.whatsapp}</td>
                                <td>{x.registeredAddress}</td>
                                <td>{x.vendorCity}</td>
                                <td>{x.vendorState}</td>
                                <td>{x.vendorCountry}</td>
                                <td>{x.vendorzipCode}</td>
                                <td>{x.officeAddress}</td>
                                <td>{x.officeCity}</td>
                                <td>{x.officeState}</td>
                                <td>{x.officeCountry}</td>
                                <td>{x.officezipCode}</td>
                                <td>{x.is_goodsSupplier}</td>
                                <td>{x.is_workServiceProvider}</td>
                                <td>{x.is_machinServices}</td>
                                <td>{x.is_mainteinance}</td>
                                <td>{x.is_labourServices}</td>
                                <td>{x.bankAcNo}</td>
                                <td>{x.AccountHolderName}</td>
                                <td>{x.IFSC}</td>
                                <td>{x.paymentTermsDays}</td>
                                <td>{x.warehouseName}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-1"> </div>
                  <div className="col-md-1">
                    {" "}
                    <button
                      className="btn  btn-primary mx-2 my-2"
                      type="submit"
                      onClick={(e) => submitHandler(e)}
                    >
                      Submit
                    </button>
                  </div>
                  <div className="col-md-1"></div>
                  <div className="col-md-1"> </div>
                  <div className="col-md-4"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VendorUpload;
